import { useState } from "react";
import img1 from "../../assests/gallery/gallery1.jpeg";
import img2 from "../../assests/gallery/gallery2.jpeg";
import img3 from "../../assests/gallery/gallery3.jpeg";
import img4 from "../../assests/gallery/gallery4.jpeg";
import img5 from "../../assests/gallery/gallery5.jpeg";
import img6 from "../../assests/gallery/gallery6.jpeg";
import img7 from "../../assests/gallery/gallery7.jpeg";
import img8 from "../../assests/gallery/gallery8.jpeg";
import img9 from "../../assests/gallery/gallery9.jpeg";
import img10 from "../../assests/gallery/gallery10.jpeg";
import img11 from "../../assests/gallery/gallery11.jpeg";
import img12 from "../../assests/gallery/gallery12.jpeg";
import img13 from "../../assests/gallery/gallery13.jpeg";
import img14 from "../../assests/gallery/gallery14.jpeg";
import img15 from "../../assests/gallery/gallery15.jpeg";
import img16 from "../../assests/gallery/gallery16.jpeg";
import img17 from "../../assests/gallery/gallery17.jpeg";
import img18 from "../../assests/gallery/gallery18.jpeg";
import img19 from "../../assests/gallery/gallery19.jpeg";
import img20 from "../../assests/gallery/gallery20.jpeg";
import img21 from "../../assests/gallery/gallery21.jpeg";
import img22 from "../../assests/gallery/gallery22.jpeg";
import img23 from "../../assests/gallery/gallery23.jpeg";
import img24 from "../../assests/gallery/gallery24.jpeg";
import img25 from "../../assests/gallery/gallery25.jpeg";
import img26 from "../../assests/gallery/gallery26.jpeg";
import img27 from "../../assests/gallery/gallery27.jpeg";
// import img28 from "../../assests/gallery/gallery28.jpeg";
import img29 from "../../assests/gallery/gallery29.jpeg";
import img30 from "../../assests/gallery/gallery30.jpeg";
import img31 from "../../assests/gallery/gallery31.jpeg";
import img32 from "../../assests/gallery/gallery32.jpeg";
import img33 from "../../assests/gallery/gallery33.jpeg";
import img34 from "../../assests/gallery/gallery34.jpeg";
import img35 from "../../assests/gallery/gallery35.jpeg";
import img36 from "../../assests/gallery/gallery36.jpeg";
import img37 from "../../assests/gallery/gallery37.jpeg";
import img38 from "../../assests/gallery/gallery38.jpeg";
import img39 from "../../assests/gallery/gallery39.jpeg";
import img40 from "../../assests/gallery/gallery40.jpeg";
import img41 from "../../assests/gallery/gallery41.jpeg";
import img42 from "../../assests/gallery/gallery42.jpeg";
import img43 from "../../assests/gallery/gallery43.jpeg";

const images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img29, img30,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42, img43
];

const ImageGallery = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);

  const openModal = (index) => {
    setCurrentIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentIndex(null);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="w-full py-20 border-b border-black relative">
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-6 p-4 ">
        {images.map((src, index) => (
          <div
            key={index}
            onClick={() => openModal(index)}
            className="relative rounded-lg shadow-lg transition-transform duration-300 cursor-pointer transform hover:scale-105 bg-white"
          >
            <img
              src={src}
              alt={`gallery-${index}`}
              className="w-full h-60  rounded-lg"
            />
          </div>
        ))}
      </div>

      {modalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="relative"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[currentIndex]}
              alt="Selected"
              className="max-w-[90vw] max-h-[80vh] rounded-lg object-contain"
            />
            <button
              onClick={goToPrev}
              className="absolute top-1/2 left-[-120px] transform -translate-y-1/2 bg-white text-black px-4 py-2 rounded-full shadow hover:bg-gray-200"
            >
              &#8592; Prev
            </button>
            <button
              onClick={goToNext}
              className="absolute top-1/2 right-[-120px] transform -translate-y-1/2 bg-white text-black px-4 py-2 rounded-full shadow hover:bg-gray-200"
            >
              Next &#8594;
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageGallery;
